import { UserRepository } from "../../repositories/UserRepository";

/**
 * Update User Permissions Use Case
 * Updates user's permissions
 */
export class UpdateUserPermissionsUseCase {
  constructor(private repository: UserRepository) {}

  async execute(
    userId: number,
    permissions: Record<string, Record<string, boolean>>
  ): Promise<void> {
    if (!userId || userId <= 0) {
      throw new Error("Invalid user ID");
    }

    if (!permissions || typeof permissions !== "object") {
      throw new Error("Permissions must be an object");
    }

    return await this.repository.updateUserPermissions(userId, permissions);
  }
}
